import { PiPhoneCallFill } from "react-icons/pi";
import { iconSize } from "../../constants/iconSize";
import { BtnCallMe, ShakeIcon  } from "./CallMe.styled";
import ReactGA from 'react-ga';

const CallMeButton = () => {
    const handlePhoneClick = () => {
        ReactGA.event({
            category: 'Button Click',
            action: 'Clicked: Кнопка дзвінка (плаваюча)'
        });
    };

    return (
        <div>
            <BtnCallMe as="a" href="tel:+380992309018" onClick={handlePhoneClick} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', textDecoration: 'none' }}>
                <ShakeIcon><PiPhoneCallFill size={iconSize.big} /></ShakeIcon>
            </BtnCallMe>
        </div>
    )
}

export default CallMeButton;
